// compile-time check for a reducer to handle all of defined actions
const defaultReducer = <S>(state: S, _action: never): S => state;

export default defaultReducer;